import React from "react";

import { Option, Select } from "src/base-components/Select";
import { UnionChoice } from "src/jsonSchema/viewer/viewModelTreeBuilder";

type TypeSwitchDropdownProps = {
  choices: UnionChoice[];
  selectedIndex: number;
  onSelectionChange: (index: number) => void;
};

export const TypeSwitchDropdown: React.FC<TypeSwitchDropdownProps> = ({
  choices,
  selectedIndex,
  onSelectionChange,
}) => {
  if (choices == null || choices.length <= 1) {
    return null; // Don't show dropdown if there's only one option
  }

  const getChoiceLabel = (choice: UnionChoice, index: number): string =>
    choice.typeLabel || `option ${index + 1}`;

  const handleChange = (value: string) => {
    const index = parseInt(value, 10);
    onSelectionChange(index);
  };

  const buttonRenderer = (option?: Option) => {
    if (!option) return "Select type";
    return (
      <span className="font-code-12 text-gray-400">
        {getChoiceLabel(
          choices[parseInt(option.key, 10)],
          parseInt(option.key, 10),
        )}
      </span>
    );
  };

  return (
    <div className="inline-block">
      <Select
        buttonRenderer={buttonRenderer}
        options={choices.map((choice, index) => ({
          key: index.toString(),
          value: getChoiceLabel(choice, index),
        }))}
        placeholder="Select type"
        value={selectedIndex.toString()}
        compact
        onChange={handleChange}
      />
    </div>
  );
};
